<script>
  import { layoutMethods, customerMethods, customerListComputed, peddlrWalletMethods, peddlrWalletComputed} from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Swal from "sweetalert2";

  const DB_WALLET_TYPE = {
    PEDDLR_WALLET: "peddlr wallet",
    BILLS_PAYMENT_WALLET: "bills payment wallet",
    ELOAD_WALLET: "eload wallet",
    ERENTA_WALLET: "erenta wallet"
  }

  const DB_WALLET_STATUS = {
    FREEZE: 'Freeze',
    ENABLED: 'Enabled'
  }
  

  /**
   * Profile Wallet component
   */
  export default {
    page: {
      title: "Profile Wallet"
    },
    components: {
      flatPickr
    },
    computed: {
      ...customerListComputed,
      ...peddlrWalletComputed,
    }, 
    data() {
      return {
        title: "Profile Wallet",
        searchValue: {
          dateRange: null,
          status: null,
          wallet: null,
          sort: 'c.id',
          orderDesc: true,
          page: 1,
          rows: 10,
        },
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        sortBy: "value",
        sortDesc: false,
        rangeOptions: {
          mode: "range",
        },
        statusOption: [
          { text: "Search All", value: null },
          { text: "Freezed", value: 1 },
          { text: "Enabled", value: 0 }
        ],
        walletOption: [
          { text: "Search All", value: null },
          { text: "Peddlr Wallet", value: 'peddlr wallet' },
          { text: "Bills Payment", value: 'bills payment wallet' },
          { text: "E-load", value: 'eload wallet' },
          { text: "E-Renta Wallet", value: 'erenta wallet' },
        ],
        fields: [
          {key: "freezeStatus", label: "Wallet Status", sortable: true},
          {key: "reason", sortable: true},
          {key: "wallet_type", sortable: true, label: 'Wallet'},
          {key: "modifiedAt", sortable: true, label: 'Date'},
          {key: "modifiedByName", labe: "Modified By", sortable: true},
        ],
        businessId: 0,
        infoType  : null,
        walletStatus: {
          "peddlrWallet" : true,
          "billsPayment" : true,
          "eLoad"        : true,
          "eRenta"       : true,
        }, 
        updateForm:{
          walletType:null,
          walletStatus:false,
          walletReason:'',
          walletName:null
        },
        isSubmitted:false,
        freezeReasonOptions : [
          { value: '', text: 'Select Reason', disabled: true},
          { text: 'Suspicious Transaction', value: 'Suspicious Transaction' },
          { text: 'Fraudulent Activity', value: 'Fraudulent Activity' },
          { text: 'Need to re-KYC', value: 'Need to re-KYC' },
          // { text: 'Bugs/Issues', value: 'Bugs/Issues' },
          // { text: 'Account Has Been Compromised', value: 'Account Has Been Compromised' },
        ],
        enableReasonOptions : [
          { value: '', text: 'Select Reason', disabled: true},
          { text: 'Cleared by Management', value: 'Cleared by Management' },
          { text: 'Identified as Bugs/Issue', value: 'Identified as Bugs/Issue' },
          { text: 'No Hacking Identified', value: 'No Hacking Identified' },
          { text: 'Cleared from BSP Watchlist', value: 'Cleared from BSP Watchlist' },
        ],
      };
    },
    methods: {
      ...layoutMethods,
      ...customerMethods,
      ...peddlrWalletMethods,
      openModal(modal=''){
        this.$bvModal.show(modal);
      },
      closeModal(modal=''){
        if (modal == 'bv-modal-reason-log') {
          this.searchValue = {
            dateRange: null,
            status: null,
            wallet: null,
            sort: 'c.id',
            orderDesc: true,
            page: 1,
            rows: 10,
          }
        }
        this.$bvModal.hide(modal);
      },
      async onSearch(state = ''){
          console.log("onsearch");
          if(state == 'reset'){
            this.searchValue.page = 1;
          }
      },
      onExport(){

      },
      tableSort(ctx){//context
        let column = '';
        switch (ctx.sortBy) {
          case 'freezeStatus':
            column = 'status';
            break;
          case 'reason':
            column = 'reason';
            break;
          case 'wallet_type':
            column = 'wallet_type';
            break;
          case 'modifiedAt':
            column = 'date';
            break;
          case 'modifiedByName':
            column = 'name';
            break;
          default:
            column = 'id';
            break;
        }

        this.searchValue.sort = column;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting...",ctx);
        this.getReasonLogs();
      },
      freezeWallet(type){
        this.isSubmitted = false;
        var walletName = null;
        switch (type) {
          case "peddlrWallet":
            walletName = "Peddlr Wallet"
            break;
          case "billsPayment":
            walletName = "Bills Payment"
            break;
          case "eLoad":
            walletName = "E-Load Wallet"
            break;
          case "eRenta":
            walletName = "E-Renta Wallet"
            break;
          default:
            break;
        }
        let status = !this.walletStatus[type] ? 'enable' : 'freeze';
        Swal.fire({ 
            title: 'Are you sure?',
            text: `You want to ${status} the ${walletName}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
              this.updateForm.walletType  = type
              this.updateForm.walletStatus= this.walletStatus[type]
              this.updateForm.walletName  = walletName
              this.updateForm.walletReason  = ""
              this.openModal('bv-modal-wallet-update');
            } else {
              this.walletStatus[type] = !this.walletStatus[type]
            }
        })
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      async submitAccountFreeze() {
        // this.isSubmitted = true;

        let formatWalletType = "";

        switch (this.updateForm.walletType) {
          case 'peddlrWallet':
            formatWalletType = DB_WALLET_TYPE.PEDDLR_WALLET
            break;
          
          case 'billsPayment':
            formatWalletType = DB_WALLET_TYPE.BILLS_PAYMENT_WALLET
            break;

          case 'eLoad':
            formatWalletType = DB_WALLET_TYPE.ELOAD_WALLET
            break;

          case 'eRenta':
            formatWalletType = DB_WALLET_TYPE.ERENTA_WALLET
            break;
        
          default:
            break;
        }

        let requestPayload = {
          userId: this.businessDetails.subscriberId,
          businessId: this.businessId,
          walletType: formatWalletType,
          walletStatus: this.updateForm.walletStatus ? DB_WALLET_STATUS.ENABLED : DB_WALLET_STATUS.FREEZE,
          reason: this.updateForm.walletReason
        }

        await this.updateUserWalletStatus({
            ...requestPayload
        }).then((res) => {
            if (res.status === "ok") {
              // Swal.fire("Success!", `Update successful.`, "success");

              Swal.fire({
                title: "Success!",
                text: "Update successful.",
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: 'btn-confirm',
                }
              }).then((result) => {
                if (result.isConfirmed) {
                    let params = {
                      businessId: this.businessId,
                      status: this.updateForm.walletStatus ? '0' : '1',
                      reason: this.updateForm.walletReason,
                      modified_by: JSON.parse(localStorage.getItem("userData")).email,
                      walletType: formatWalletType
                    }

                    // update the account_freeze status
                    this.updateWalletStatus(params)
                      .then(() => {
                          
                      })
                      .catch((error) => {
                          console.error("err", error);
                      });
                }
              });
            }
        }).catch((err) => {
            console.error("err", err);
        });
        
      },
      async showReasonLogsModal() {
        this.getReasonLogs()
          .then(() => {
            this.openModal('bv-modal-reason-log')
          })
      },
      async fetchUserWalletsList(){
        let requestPayload = {
          businessId: this.businessId
        }

        await this.getUserWalletsList({
            ...requestPayload
        }).then((res) => {
          let walletsList = res;

          walletsList.forEach(w => {
            switch (w.walletType) {
              case DB_WALLET_TYPE.PEDDLR_WALLET: {
                this.walletStatus['peddlrWallet'] = w.walletStatus == DB_WALLET_STATUS.ENABLED ? true : false
                break;
              }

              case DB_WALLET_TYPE.BILLS_PAYMENT_WALLET: {
                this.walletStatus['billsPayment'] = w.walletStatus == DB_WALLET_STATUS.ENABLED ? true : false
                break;
              }

              case DB_WALLET_TYPE.ELOAD_WALLET: {
                this.walletStatus['eLoad'] = w.walletStatus == DB_WALLET_STATUS.ENABLED ? true : false
                break;
              }

              case DB_WALLET_TYPE.ERENTA_WALLET: {
                this.walletStatus['eRenta'] = w.walletStatus == DB_WALLET_STATUS.ENABLED ? true : false
                break;
              }

              default:
                break;
            }
          });
        }).catch((err) => {
            console.error("err", err);
        });
      },
      async getReasonLogs() {
        this.searchValue.page = this.isSearching ? 1 : this.searchValue.page;

        let params = {
          businessId: this.businessId,
          dateRange: this.searchValue.dateRange,
          page: this.searchValue.page,
          rows: this.searchValue.rows,
          sort: this.searchValue.sort,
          orderDesc: this.searchValue.orderDesc,
          status: this.searchValue.status,
          walletType: this.searchValue.wallet
        };

        this.getReasonLogsList(params)
          .then(() => {
            this.isSearching = false;
          });
      },
      isEmpty (value) {
          return (
            // null or undefined
            (typeof value == "undefined") || 
            (value == undefined) ||
            (value == null) ||
            (value === "") ||
            // has length and it's zero
            // (value.hasOwnProperty('length') && value.length === 0) ||
            (Object.prototype.hasOwnProperty.call(value, length) && value.length === 0) ||
            // is an Object and has no keys
            (value.constructor === Object && Object.keys(value).length === 0)
          )
      }
    },
    async mounted(){
      this.businessId = this.$route.params.bid
      this.infoType = this.$route.params.tab;
      await this.fetchUserWalletsList();
      this.getPeddlrWalletDetails({ businessId: this.businessId });
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
    <div class="card">
      <div class="d-flex border-top p-2 px-3 border-bottom text-dark">
          <div class="flex-grow-1 my-auto pt-1 row">
              <h5 class="mb-0 font-size-14 col-6 mt-1">Wallet Balance</h5>
          </div>
      </div>
      <ul class="list-unstyled mb-0">
          <li class="py-3 p-2 px-3 border-bottom pb-0"> <!-- Peddlr Wallet -->
              <div class="float-end text-end">
                <input type="checkbox" id="switch1" switch="bool" checked="checked" v-model="walletStatus.peddlrWallet" @click="freezeWallet('peddlrWallet')"/>
                <label for="switch1" data-on-label="Enabled" data-off-label="Freezed" class="mb-0"></label>
              </div>
              <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3 fw-semibold">
                      <i class='mdi mdi-wallet' :class="{ 'text-muted': businessDetails.account_freeze }"></i>
                  </div>
                  <div class="flex-grow-1 fw-semibold" :class="{ 'text-muted': businessDetails.account_freeze }">
                      <p class="mb-1 font-size-13">Peddlr Wallet</p>
                      <h5 class="mb-0 font-size-14 fw-normal" :class="{ 'text-muted': businessDetails.account_freeze }">
                        {{ peddlrWalletDetails.availableBalance ? peddlrWalletDetails.availableBalance : 0 | numberWithCommas }}
                      </h5>
                  </div>
              </div>
              <div class="d-flex align-items-center mt-2">
                  <div class="flex-grow-1 row">
                      <p class="mb-1 font-size-12 col-6">Transaction:</p>
                      <div class="mb-1 col-6 text-end" :class="{ 'pe-none': peddlrWalletDetails.cognito_sub == null }">
                          <router-link :to="{ name: 'Profile Information Wallet', params: { tab: infoType, bid: businessId, wallet: 'peddlr-wallet' }}"
                            :class="{ 'text-muted': peddlrWalletDetails.cognito_sub == null }" :disabled="peddlrWalletDetails.cognito_sub == null">
                            View
                          </router-link>
                      </div>
                  </div>
              </div>
          </li>
          <!-- end li -->
          <li class="py-3 p-2 px-3 border-bottom pb-0"> <!-- Bills Payment Wallet -->
              <div class="float-end text-end">
                <input type="checkbox" id="switch2" switch="bool" checked="checked" v-model="walletStatus.billsPayment" @click="freezeWallet('billsPayment')"/>
                <label for="switch2" data-on-label="Enabled" data-off-label="Freezed" class="mb-0"></label>
              </div>
              <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3 fw-semibold">
                      <i class='mdi mdi-wallet' :class="{ 'text-muted': businessDetails.account_freeze }"></i>
                  </div>
                  <div class="flex-grow-1 fw-semibold" :class="{ 'text-muted': businessDetails.account_freeze }">
                      <p class="mb-1 font-size-13">Bills Payment</p>
                      <h5 class="mb-0 font-size-14 fw-normal" :class="{ 'text-muted': businessDetails.account_freeze }">
                        {{ businessDetails.billsBalance | numberWithCommas }}
                      </h5>
                  </div>
              </div>
              <div class="d-flex align-items-center mt-2">
                  <div class="flex-grow-1 row">
                      <p class="mb-1 font-size-12 col-6">Transaction:</p>
                      <div class="mb-1 col-6 text-end">
                          <router-link :to="{ name: 'Profile Information Wallet', params: { tab: infoType, bid: businessId, wallet: 'bills-payment' }}">
                            View
                          </router-link>
                      </div>
                  </div>
              </div>
          </li>
          <!-- end li -->
          <li class="py-3 p-2 px-3 border-bottom pb-0"> <!-- E-Load Wallet -->
              <div class="float-end text-end">
                <input type="checkbox" id="switch3" switch="bool" checked="checked" v-model="walletStatus.eLoad" @click="freezeWallet('eLoad')"/>
                <label for="switch3" data-on-label="Enabled" data-off-label="Freezed" class="mb-0"></label>
              </div>
              <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3 fw-semibold">
                      <i class='mdi mdi-wallet' :class="{ 'text-muted': businessDetails.account_freeze }"></i>
                  </div>
                  <div class="flex-grow-1 fw-semibold" :class="{ 'text-muted': businessDetails.account_freeze }">
                      <p class="mb-1 font-size-13">E-load</p>
                      <h5 class="mb-0 font-size-14 fw-normal" :class="{ 'text-muted': businessDetails.account_freeze }">
                        {{ businessDetails.eloadBalance | numberWithCommas }}
                      </h5>
                  </div>
              </div>
              <div class="d-flex align-items-center mt-2">
                  <div class="flex-grow-1 row">
                      <p class="mb-1 font-size-12 col-6">Transaction:</p>
                      <div class="mb-1 col-6 text-end">
                          <router-link :to="{ name: 'Profile Information Wallet', params: { tab: infoType, bid: businessId, wallet: 'e-load' }}">
                            View
                          </router-link>
                      </div>
                  </div>
              </div>
          </li>
          <!-- end li -->
          <li class="py-3 p-2 px-3 border-bottom pb-0"> <!-- E-Renta Wallet -->
              <div class="float-end text-end">
                <input type="checkbox" id="switch4" switch="bool" checked="checked" v-model="walletStatus.eRenta" @click="freezeWallet('eRenta')"/>
                <label for="switch4" data-on-label="Enabled" data-off-label="Freezed" class="mb-0"></label>
              </div>
              <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3 fw-semibold">
                      <i class='mdi mdi-wallet' :class="{ 'text-muted': businessDetails.account_freeze }"></i>
                  </div>
                  <div class="flex-grow-1 fw-semibold" :class="{ 'text-muted': businessDetails.account_freeze }">
                      <p class="mb-1 font-size-13">E-Renta Wallet</p>
                      <h5 class="mb-0 font-size-14 fw-normal" :class="{ 'text-muted': businessDetails.account_freeze }">
                        {{ 0 | numberWithCommas }}
                      </h5>
                  </div>
              </div>
              <div class="d-flex align-items-center mt-2">
                  <div class="flex-grow-1 row">
                      <p class="mb-1 font-size-12 col-6">Transaction:</p>
                      <div class="mb-1 col-6 text-end">
                          <router-link :to="{ name: 'Profile Information Wallet', params: { tab: infoType, bid: businessId, wallet: 'e-renta' }}">
                            View
                          </router-link>
                      </div>
                  </div>
              </div>
          </li>
          <!-- end li -->
          <li class="py-3 p-2 px-3"> <!-- Reason Log -->
              <div class="d-flex align-items-center">
                  <div class="flex-grow-1 row">
                      <p class="mb-1 font-size-13 col-6">Reason Log:</p>
                      <div class="mb-1 col-6 text-end">
                          <b-link class="small fw-semibold text-muted" @click="showReasonLogsModal()">View</b-link>
                      </div>
                  </div>
              </div>
          </li>
          <!-- end li -->
      </ul>
    </div>


    <!-- MODAL -->
    <b-modal id="bv-modal-reason-log" title="Reason Log" size="xl" hide-header hide-title hide-footer hide-header-close>
      <span class="float-end c-pointer " @click="closeModal('bv-modal-reason-log')"><i class="bx bx-x fs-3"></i></span>
      <h5>Reason Log</h5>
      <div class="d-flex flex-wrap mt-4 mb-2">
        <div class="me-2 ta-right">
          <b-form-group description="Filter by date">
            <flat-pickr
              v-model="searchValue.dateRange"
              :config="rangeOptions"
              placeholder="Select a date range"
              class="form-control"
              style="width: fit-content"
            ></flat-pickr>
          </b-form-group>
        </div>
        <div class="me-2 ta-right">
          <b-form-group label-for="acctStatus" description="Filter by Status">
            <b-form-select class="form-select rounded shadow-none" style="width:160px"
              id="acctStatus"
              v-model="searchValue.status"
              :options="statusOption"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="me-2 ta-right">
          <b-form-group label-for="wallet" description="Filter by Wallet">
            <b-form-select class="form-select rounded shadow-none" style="width:160px"
              id="wallet"
              v-model="searchValue.wallet"
              :options="walletOption"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="me-2">
          <a class="btn btn-primary h-fit" @click="isSearching = true; getReasonLogs()">
            <i class='bx bx-search bx-fw'></i>Search
          </a>
        </div>
        <div class="me-2" v-if="false">
          <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
            <i class="uil uil-export me-1"></i>
            Export
          </a>
        </div>
      </div>

      <div class="table-responsive mb-0">
        <div class="table align-middle table-nowrap">
          <b-table
            :items="reasonLogsList"
            :fields="fields"
            responsive="sm"
            :current-page="searchValue.page"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="table-check"
            @sort-changed="tableSort" 
          >

          <template #cell(freezeStatus)="data">
            {{ data.item.freezeStatus ? "Freezed" : "Enabled" }}
          </template>

          <template #cell(modifiedAt)="data">
            {{ data.item.modifiedAt | formatDate }}
          </template>

          <template #cell(wallet_type)="data">
            <span class="text-capitalize">{{ data.item.wallet_type }}</span>
          </template>

          </b-table>
        </div>
      </div>
      <!-- end table responsive -->
      <div class="row g-0 text-center" v-if="reasonLogsTotal == 0">
        <span>No data to display.</span>
      </div>
      <div class="p-2"></div>

      <div class="row">
        <div class="col">
          <div class="form-group row pull-left">
            <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
            <div class="col-sm-6">
              <b-form-group label-for="display-record">
                <b-form-select class="form-select shadow-none w-fit"
                  id="display-record"
                  v-model="searchValue.rows"
                  :options="pageOptions"
                  @change="getReasonLogs()"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div
            class="
              dataTables_paginate
              paging_simple_numbers
              float-end
            "
          >
            <b-pagination
              class="pagination-rounded"
              v-model="searchValue.page"
              :total-rows="reasonLogsTotal"
              @input="getReasonLogs()"
              :per-page="searchValue.rows"
            ></b-pagination>
          </div>
        </div> 
      </div>


      <div class="ta-right">
        <a class="btn btn-light h-fit" @click="closeModal('bv-modal-reason-log')">
          Close
        </a>
      </div>

    </b-modal><!--bv-modal-reason-log-->

    <b-modal id="bv-modal-wallet-update"
      size="md"
      centered
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
    >
        <ValidationObserver v-slot="{ handleSubmit, reset }">
          <b-form
            ref="AccountFreeze"
            @submit.prevent="handleSubmit(submitAccountFreeze)"
            @reset.prevent="reset"
          >
            <div class="row">
              <div class="col-md-12 text-center">
                <div class="mb-1">
                  <i class="mdi mdi-wallet wallet-icon-custom text-secondary"></i>
                </div>
                <p class="form-label large fw-bold mt-2" style="font-size: 1.5em;">{{updateForm.walletName}}</p>
                <p class="form-label mt-2 mb-3 px-5">Before you {{ updateForm.walletStatus ? 'enable' : 'freeze' }} the {{updateForm.walletName}}, please let us know the reason.</p>
              </div>

              <div class="col-md-12 mb-3 px-3">
                <validation-provider
                  name="reason"
                  rules="required"
                  v-slot="validationContext"
                >
                  <b-form-select
                    class="form-select" 
                    v-model="updateForm.walletReason"
                    :options="updateForm.walletStatus ? enableReasonOptions : freezeReasonOptions"
                    track-by="value"
                    label="text"
                    :state="getValidationState(validationContext)"
                    />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
            </div>
            <div class="text-end mt-3 px-1">

              <b-button
                variant="light"
                class="w-sm me-3"
                @click="closeModal('bv-modal-wallet-update'); 
                walletStatus[updateForm['walletType']] = !walletStatus[updateForm['walletType']]"
                >Cancel</b-button
              >
              <b-button
                type="submit"
                variant="primary"
                @click="closeModal('bv-modal-wallet-update');"
                :disabled="(isSubmitted || (!isEmpty(updateForm.walletReason) && updateForm.walletReason.length > 150))"
              >
                <span
                  v-if="isSubmitted"
                  class="spinner-grow spinner-grow-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Save
              </b-button>
            </div>
          </b-form>
        </ValidationObserver>
    </b-modal><!--bv-modal-wallet-update-->

  </div> <!-- end of outer div-->
</template>

<style>
.wallet-icon-custom {
  font-size: 7em;
  color: #0e0e0e;
}

input[switch] + label {
  width: 78px;
}

input[switch]:checked + label:after {
    left: 55px;
}
</style>